// extracted by mini-css-extract-plugin
module.exports = {"actions":"CustomBadge_actions__1v2ey","image":"CustomBadge_image__p7iH6","button":"CustomBadge_button__2guN6"};